import { withMetadata } from '../metadata'
import { findNumbers as _findNumbers } from '../../core/index'

export function findNumbers() {
	return withMetadata(_findNumbers, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/min/exports/findNumbers.js
// module id = 626
// module chunks = 0